import { IOrigins } from '../models';

export const getLanguages: IOrigins[] = [
    { code: 'aa', label: 'Afar' },
    { code: 'ab', label: 'Abchazisch' },
    { code: 'ae', label: 'Avestisch' },
    { code: 'af', label: 'Afrikaans' },
    { code: 'ak', label: 'Akan' },
    { code: 'am', label: 'Amhaars' },
    { code: 'an', label: 'Aragonees' },
    { code: 'ar', label: 'Arabisch' },
    { code: 'as', label: 'Assamees' },
    { code: 'av', label: 'Avaars' },
    { code: 'ay', label: 'Aymara' },
    { code: 'az', label: 'Azerbeidzjaans' },
    { code: 'ba', label: 'Basjkiers' },
    { code: 'be', label: 'Wit-Russisch' },
    { code: 'bg', label: 'Bulgaars' },
    { code: 'bh', label: 'Bihari' },
    { code: 'bi', label: 'Bislama' },
    { code: 'bm', label: 'Bambara' },
    { code: 'bn', label: 'Bengaals' },
    { code: 'bo', label: 'Tibetaans' },
    { code: 'br', label: 'Bretons' },
    { code: 'bs', label: 'Bosnisch' },
    { code: 'ca', label: 'Catalaans' },
    { code: 'ce', label: 'Tsjetsjeens' },
    { code: 'ch', label: 'Chamorro' },
    { code: 'co', label: 'Corsicaans' },
    { code: 'cr', label: 'Cree' },
    { code: 'cs', label: 'Tsjechisch' },
    { code: 'cu', label: 'Kerkslavisch' },
    { code: 'cv', label: 'Tsjoevasjisch' },
    { code: 'cy', label: 'Welsh' },
    { code: 'da', label: 'Deens' },
    { code: 'de', label: 'Duits' },
    { code: 'dv', label: 'Divehi' },
    { code: 'dz', label: 'Dzongkha' },
    { code: 'ee', label: 'Ewe' },
    { code: 'el', label: 'Grieks' },
    { code: 'en', label: 'Engels' },
    { code: 'eo', label: 'Esperanto' },
    { code: 'es', label: 'Spaans' },
    { code: 'et', label: 'Estisch' },
    { code: 'eu', label: 'Baskisch' },
    { code: 'fa', label: 'Perzisch' },
    { code: 'ff', label: 'Fula' },
    { code: 'fi', label: 'Fins' },
    { code: 'fj', label: 'Fijisch' },
    { code: 'fo', label: 'Faeröers' },
    { code: 'fr', label: 'Frans' },
    { code: 'fy', label: 'Westerlauwers Fries' },
    { code: 'ga', label: 'Iers' },
    { code: 'gd', label: 'Schots-Gaelisch' },
    { code: 'gl', label: 'Galicisch' },
    { code: 'gn', label: 'Guaraní' },
    { code: 'gu', label: 'Gujarati' },
    { code: 'gv', label: 'Manx-Gaelisch' },
    { code: 'ha', label: 'Hausa' },
    { code: 'he', label: 'Hebreeuws' },
    { code: 'hi', label: 'Hindi' },
    { code: 'ho', label: 'Hiri Motu' },
    { code: 'hr', label: 'Kroatisch' },
    { code: 'ht', label: 'Haïtiaans Creools' },
    { code: 'hu', label: 'Hongaars' },
    { code: 'hy', label: 'Armeens' },
    { code: 'hz', label: 'Herero' },
    { code: 'ia', label: 'Interlingua' },
    { code: 'id', label: 'Indonesisch' },
    { code: 'ie', label: 'Interlingue' },
    { code: 'ig', label: 'Igbo' },
    { code: 'ii', label: 'Yi' },
    { code: 'ik', label: 'Inupiak' },
    { code: 'io', label: 'Ido' },
    { code: 'is', label: 'IJslands' },
    { code: 'it', label: 'Italiaans' },
    { code: 'iu', label: 'Inuktitut' },
    { code: 'ja', label: 'Japans' },
    { code: 'jv', label: 'Javaans' },
    { code: 'ka', label: 'Georgisch' },
    { code: 'kg', label: 'Kongo' },
    { code: 'ki', label: 'Gikuyu' },
    { code: 'kj', label: 'Kwanyama' },
    { code: 'kk', label: 'Kazachs' },
    { code: 'kl', label: 'Groenlands' },
    { code: 'km', label: 'Khmer' },
    { code: 'kn', label: 'Kannada' },
    { code: 'ko', label: 'Koreaans' },
    { code: 'kr', label: 'Kanuri' },
    { code: 'ks', label: 'Kasjmiri' },
    { code: 'ku', label: 'Koerdisch' },
    { code: 'kv', label: 'Zurjeens' },
    { code: 'kw', label: 'Cornisch' },
    { code: 'ky', label: 'Kirgizisch' },
    { code: 'la', label: 'Latijn' },
    { code: 'lb', label: 'Luxemburgs' },
    { code: 'lg', label: 'Luganda' },
    { code: 'li', label: 'Limburgs' },
    { code: 'ln', label: 'Lingala' },
    { code: 'lo', label: 'Laotiaans' },
    { code: 'lt', label: 'Litouws' },
    { code: 'lu', label: 'Luba-Katanga' },
    { code: 'lv', label: 'Lets' },
    { code: 'mg', label: 'Plateaumalagasi' },
    { code: 'mh', label: 'Marshallees' },
    { code: 'mi', label: 'Maori' },
    { code: 'mk', label: 'Macedonisch' },
    { code: 'ml', label: 'Malayalam' },
    { code: 'mn', label: 'Mongools' },
    { code: 'mr', label: 'Marathi' },
    { code: 'ms', label: 'Maleis' },
    { code: 'mt', label: 'Maltees' },
    { code: 'my', label: 'Birmaans' },
    { code: 'na', label: 'Nauruaans' },
    { code: 'nb', label: 'Bokmål-Noors' },
    { code: 'nd', label: 'Noord-Ndebele' },
    { code: 'ne', label: 'Nepalees' },
    { code: 'ng', label: 'Ndonga' },
    { code: 'nl', label: 'Nederlands' },
    { code: 'nn', label: 'Nynorsk' },
    { code: 'no', label: 'Noors' },
    { code: 'nr', label: 'Zuid-Ndebele' },
    { code: 'nv', label: 'Navajo' },
    { code: 'ny', label: 'Nyanja' },
    { code: 'oc', label: 'Occitaans' },
    { code: 'oj', label: 'Ojibweg' },
    { code: 'om', label: 'Afaan Oromo' },
    { code: 'or', label: 'Odia' },
    { code: 'os', label: 'Ossetisch' },
    { code: 'pa', label: 'Punjabi' },
    { code: 'pi', label: 'Pali' },
    { code: 'pl', label: 'Pools' },
    { code: 'ps', label: 'Pasjtoe' },
    { code: 'pt', label: 'Portugees' },
    { code: 'qu', label: 'Quechua' },
    { code: 'rm', label: 'Reto-Romaans' },
    { code: 'rn', label: 'Kirundi' },
    { code: 'ro', label: 'Roemeens' },
    { code: 'ru', label: 'Russisch' },
    { code: 'rw', label: 'Kinyarwanda' },
    { code: 'sa', label: 'Sanskriet' },
    { code: 'sc', label: 'Sardijns' },
    { code: 'sd', label: 'Sindhi' },
    { code: 'se', label: 'Noord-Samisch' },
    { code: 'sg', label: 'Sango' },
    { code: 'si', label: 'Singalees' },
    { code: 'sk', label: 'Slowaaks' },
    { code: 'sl', label: 'Sloveens' },
    { code: 'sm', label: 'Samoaans' },
    { code: 'sn', label: 'Shona' },
    { code: 'so', label: 'Somalisch' },
    { code: 'sq', label: 'Albanees' },
    { code: 'sr', label: 'Servisch' },
    { code: 'ss', label: 'Swazi' },
    { code: 'st', label: 'Zuid-Sotho' },
    { code: 'su', label: 'Soendanees' },
    { code: 'sv', label: 'Zweeds' },
    { code: 'sw', label: 'Swahili' },
    { code: 'ta', label: 'Tamil' },
    { code: 'te', label: 'Telugu' },
    { code: 'tg', label: 'Tadzjieks' },
    { code: 'th', label: 'Thai' },
    { code: 'ti', label: 'Tigrinya' },
    { code: 'tk', label: 'Turkmeens' },
    { code: 'tl', label: 'Tagalog' },
    { code: 'tn', label: 'Tswana' },
    { code: 'to', label: 'Tongaans' },
    { code: 'tr', label: 'Turks' },
    { code: 'ts', label: 'Tsonga' },
    { code: 'tt', label: 'Tataars' },
    { code: 'tw', label: 'Twi' },
    { code: 'ty', label: 'Tahitiaans' },
    { code: 'ug', label: 'Oeigoers' },
    { code: 'uk', label: 'Oekraïens' },
    { code: 'ur', label: 'Urdu' },
    { code: 'uz', label: 'Oezbeeks' },
    { code: 've', label: 'Venda' },
    { code: 'vi', label: 'Vietnamees' },
    { code: 'vo', label: 'Volapük' },
    { code: 'wa', label: 'Waals' },
    { code: 'wo', label: 'Wolof' },
    { code: 'xh', label: 'Xhosa' },
    { code: 'yi', label: 'Jiddisch' },
    { code: 'yo', label: 'Yoruba' },
    { code: 'za', label: 'Zhuang' },
    { code: 'zh', label: 'Chinese talen' },
    { code: 'zu', label: 'Zoeloe' },
];
